import {
  Autocomplete,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material'
import type { FC } from 'react'
import { type Control, Controller } from 'react-hook-form'
import { LabelFormValues } from '../LabelFormContext/useLabelForm'

type Props = {
  control: Control<LabelFormValues>
  options: string[]
}

export const LabelName: FC<Props> = ({ control, options }) => {
  return (
    <Controller
      name="labelName"
      control={control}
      rules={{
        maxLength: { value: 50, message: '50文字以内で入力してください' },
      }}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} sx={{ gap: 0.5 }}>
          <Typography
            component="label"
            sx={{
              color: 'text.primary',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            ラベル名
          </Typography>
          <Autocomplete
            freeSolo
            fullWidth
            options={options}
            value={field.value}
            onChange={(_, newValue) => {
              field.onChange(newValue ?? '')
            }}
            onInputChange={(_, newValue) => {
              field.onChange(newValue)
            }}
            renderInput={params => (
              <TextField {...params} sx={{ backgroundColor: 'white' }} />
            )}
          />
          {error ? (
            <FormHelperText sx={{ margin: 0 }}>{error.message}</FormHelperText>
          ) : (
            <Typography variant="caption" color="text.secondary">
              過去に使用されたラベル名から選択するか、新規に入力してください。
            </Typography>
          )}
        </FormControl>
      )}
    />
  )
}
